import { Button } from "@/components/ui/button";

interface GoogleAuthButtonProps {
  isLoading: boolean;
  isLogin: boolean;
  onGoogleSignIn: () => Promise<void>;
}

export const GoogleAuthButton = ({
  isLoading,
  isLogin,
  onGoogleSignIn,
}: GoogleAuthButtonProps) => {
  return (
    <Button
      type="button"
      variant="outline"
      className="w-full hover:bg-muted/50 animate-fade-in"
      onClick={onGoogleSignIn}
      disabled={isLoading}
    >
      <img
        src="https://www.google.com/favicon.ico"
        alt="Google"
        className="mr-2 h-4 w-4"
      />
      {isLogin ? "Sign in with Google" : "Sign up with Google"}
    </Button>
  );
};